"use client";

import { ButtonNav } from "@/components/common/button-nav";
import { updateSearchParams } from "@/lib/utils";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

export function ListFilter({
  filter,
  clearFilterName,
}: {
  filter: Filter;
  clearFilterName?: string;
}) {
  const pathname = usePathname();
  const router = useRouter();

  function parseOptionsToNavItems(
    options: FilterOption[],
  ): { link: string; title: string; isActive?: boolean }[] {
    return options.map((option) => ({
      link: pathname,
      searchParams: {
        [filter.name]: option.value,
      },
      title: option.name,
      isActive: filter.value === option.value,
    }));
  }

  useEffect(() => {
    if (!filter.value) {
      updateSearchParams(filter.name, null, router);
    }
  }, [filter.value, filter.name, router]);

  const clearFilterNavItem = {
    link: pathname,
    searchParams: {
      [filter.name]: "",
    },
    title: clearFilterName ?? "Wszystkie",
    isActive:
      filter.value === null ||
      filter.value === undefined ||
      filter.value === "",
  };

  const navItems = clearFilterName
    ? [clearFilterNavItem, ...parseOptionsToNavItems(filter.options ?? [])]
    : parseOptionsToNavItems(filter.options ?? []);

  return <ButtonNav navItems={navItems} />;
}
